import React from 'react';
import ReactDOM from 'react-dom';
import { ConnectedRouter } from 'connected-react-router';
import { Provider } from 'react-redux';
import { ConfigProvider } from 'antd';

import store, { history } from './store';
import './index.less';
import Routes from './routes';
import reportWebVitals from './reportWebVitals';
import ScrollToTop from './components/ScrollToTop';

const theme = {
	token: {
		fontFamily: 'Mulish,Arial',
		colorPrimary: '#003366',
		colorLink: '#0088FF',
		colorNeutral: '#000000',

		// Custom Colors
		whiteColor: '#FFFFFF'
	},
	components: {
		Menu: {
			darkItemSelectedBg: '#0088FF',
			itemHeight: 59
		},
		Button: {
			primaryShadow: null,
			contentFontSizeLG: 19
		},
		Input: {
			activeShadow: null
		},
		Steps: {
			titleLineHeight: 23
		},
		Modal: {
			titleColor: '#FFFFFF',
			headerBg: '#003366'
		}
	}
};

ReactDOM.render(
	<React.StrictMode>
		<Provider store={store()}>
			<ConnectedRouter history={history}>
				<ConfigProvider theme={theme}>
					<ScrollToTop />
					<Routes />
				</ConfigProvider>
			</ConnectedRouter>
		</Provider>
	</React.StrictMode>,
	document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
